
import {
  Component, Mixins,
} from 'vue-property-decorator';
import InstallationDateMixin from '@/mixins/InstallationDateMixin.vue';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

@Component
export default class OperationInstallationDate extends Mixins(InstallationDateMixin, OperationComponentMixin) {
  get hasAllegatiInstallazione(): boolean {
    return this.operationChild?.hasAllegatiInstallazione === true;
  }

  get missingFinishingsStatus(): string | null {
    return this.operationChild?.missingFinishingsStatus ?? null;
  }

  get missingFinishingsNotes(): string | null {
    return this.operationChild?.missingFinishingsNotes ?? null;
  }

  get hasMissingFinishings(): boolean {
    return !!this.missingFinishingsStatus && this.missingFinishingsStatus !== 'na';
  }

  get missingFinishingsColor(): string {
    switch (this.missingFinishingsStatus) {
      case 'todo': return 'orange';
      case 'waiting': return 'orange';
      case 'done': return 'success';
      default: return '';
    }
  }

  get missingFinishingsTooltipText(): string {
    const plain = (this.missingFinishingsNotes || '').replace(/<[^>]*>/g, '').trim();
    return plain || 'Finiture mancanti';
  }

  get tooltipText() {
    let text = '';

    if (this.installationCompleted) {
      text += this.partialInstallationCompleted
        ? 'Installazione parziale e finale completata'
        : 'Installazione finale completata';
    } else

    if (this.installationDate
      && (this.partialInstallationCompleted || !this.partialInstallationDate)
    ) {
      text += this.installationDateConfirm
        ? 'Data concordata per l\'installazione finale'
        : 'Data prevista per l\'installazione finale (non confermata)';
    } else

    if (this.partialInstallationCompleted) {
      text += 'Installazione parziale completata';
    } else if (this.partialInstallationDate) {
      text += this.partialInstallationDateConfirm
        ? 'Data concordata per l\'installazione parziale'
        : 'Data prevista per l\'installazione parziale (non confermata)';
    } else {
      text += 'Data prevista per l\'installazione da definire';
    }

    if (this.installationNotes
      && this.isCurrentUserOwnerOrRequester
      && this.hasPermission('taski.installationNotes.show')
    ) text += `<br>${this.installationNotes}`;

    return text;
  }
}
